import { render } from "./KsefCompanyCreate.vue?vue&type=template&id=dcc6d332&scoped=true"
import script from "./KsefCompanyCreate.vue?vue&type=script&lang=js"
export * from "./KsefCompanyCreate.vue?vue&type=script&lang=js"

import "./KsefCompanyCreate.vue?vue&type=style&index=0&id=dcc6d332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc6d332"]])

export default __exports__